// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__grtskTeraFont_f01a0e', '__grtskTeraFont_Fallback_f01a0e'","fontWeight":600,"fontStyle":"normal"},"className":"__className_f01a0e"};